document.addEventListener('DOMContentLoaded', () => {
  const buttonsLong = document.querySelectorAll('.button--long')
  if(buttonsLong) {
    window.resize = () => {
      buttonsLong.forEach(button => {

        const buttonContent = button.querySelector('.button__content')
        const buttonHover = button.querySelector('.button__hover span')
        buttonHover.setAttribute('style', `left: ${(button.clientWidth - buttonContent.clientWidth) / 2 + 4 }px`)
      })
    }

    window.addEventListener('resize', resize)
    resize()
  }
})